import { VisionApplication } from '../../application';
import { VisionWindow } from '../../window/window';
import { PreventativeMaintenanceService } from './pmservice';

class UploadWindow extends VisionWindow {
    form!: dhtmlXForm;
    url: string;

    constructor(url: string) {
        const app = VisionApplication.getInstance();

        const manager = app.windowManager;
        const height = window.innerHeight * 0.5;
        const width = window.innerWidth * 0.35;
        super(manager, {
            id: 'pm_files_upload_window',
            title: 'Upload File',
            x: 65,
            y: 65,
            width: width,
            height: height,
        });

        this.url = url;

        this.window.setText('Upload File');
        this.buildGUI();
    }

    private buildGUI(): void {
        const formData = [
            {
                type: 'fieldset',
                label: 'File Information',
                list: [
                    {
                        name: 'description',
                        type: 'input',
                        label: 'Description',
                        value: '',
                        inputWidth: '150',
                        offsetLeft: '5',
                        offsetTop: '5',
                        disabled: false,
                    },
                ],
            },
            {
                type: 'fieldset',
                label: 'Uploader',
                list: [{ type: 'upload', name: 'myFiles', inputWidth: 330, url: this.url }],
            },
            { type: 'button', name: 'send', value: 'Save' },
        ];

        this.form = this.window.attachForm(formData);
    }
}

export class PMWorkFilesWindow extends VisionWindow {
    grid!: dhtmlXGridObject;
    toolbar!: dhtmlXToolbarObject;
    service: PreventativeMaintenanceService;
    workItemId: string;

    constructor(workItemId: string, service: PreventativeMaintenanceService) {
        const app = VisionApplication.getInstance();
        const manager = app.windowManager;
        const height = window.innerHeight * 0.75;
        const width = window.innerWidth * 0.45;
        super(manager, {
            id: 'pm_files_window',
            title: 'Complete PM',
            x: 45,
            y: 45,
            width: width,
            height: height,
        });

        this.service = service;
        this.workItemId = workItemId;

        this.window.setText('Work Item File List');
        this.buildGUI();
        this.buildEvents();

        this.loadTestData();
    }

    private loadTestData(): void {
        const orgid = VisionApplication.getInstance().assetService.orgid;
        if (orgid == '49680f44-221d-4a25-a56e-b6a1afd95e8b') {
            this.grid.addRow(1, ['15/01/2025', 'Parts-R-US Tires Receipt', 'tires.pdf', 'download', 'delete'], 0, '', '', false);
        }
    }

    private buildGUI(): void {
        this.toolbar = this.window.attachToolbar();
        this.toolbar.addButton('upload', 0, 'Upload', 'css/imgs/save.gif', '');

        this.grid = this.window.attachGrid();
        this.grid.setHeader('Date,Description,File Name,Download,Delete', '', []);
        this.grid.setColTypes('txt,txt,txt,txt,txt');
        this.grid.init();
    }

    private buildEvents(): void {
        this.toolbar.attachEvent('onClick', (id) => {
            this.toolbarHandler(id);
        });
    }

    private toolbarHandler(id: string): void {
        switch (id) {
            case 'upload': {
                //const window = new UploadWindow(this.service.getPMFileUploadURL(this.workItemId));
                new UploadWindow(this.service.getPMFileUploadURL(this.workItemId));
                break;
            }
        }
    }
}
